var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortGrayUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0L5.59808 4.5L0.401924 4.5L3 0Z",
    fill: "#9BA3AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortGrayUp);
export default __webpack_public_path__ + "static/media/tableSortGrayUp.cacf36dfaae931c9d44e3d5f68a89697.svg";
export { ForwardRef as ReactComponent };